<template>
    <!-- <div class="container-fluid m-0 p-0">

        <div class="row m-0">
            <div class="col main-content px-sm-0">

                <Navbar :categories="categories" :data="top_menu_list" :TR="TR" :langs="langs" />
                <OffCanvas />

                <main class="main pt-100" style="min-height: 882px;"> -->

                    <keep-alive>
                        <component :is="loadPages" :data="currentComponent"></component>
                    </keep-alive>

                <!-- </main> -->

                <!-- <Footer id="footer_section" :data="bottom_menu_list" :socials="socials" :TR="TR" class="fixed-bottom1 p-2 p-sm-0" />

            </div>
        </div>

    </div> -->
</template>


<script>
    import { computed, defineAsyncComponent, onBeforeMount, ref, watchEffect } from "vue";

    import { useRoute } from "vue-router";
    import { useStore } from "@/system_modules/store";

    // import { useHead } from '@unhead/vue';

    import Navbar from "@/components/navbar/Navbar";
    import OffCanvas from "@/components/navbar/OffCanvas";
    import Footer from '@/components/footer/Footer2';

    import moment from 'moment-timezone';
    import 'moment/locale/az';
    // import 'moment/locale/en';

    import { G, ajax } from "@/_common";

    export default {
        name: 'MainL',
        components: {
            Navbar,
            OffCanvas,
            Footer,
            // Footer: Footer,
        },
        props: {
            data: {
                type: Object,
            },
        },
        // watch: {
        //     $route(to) {
        //     // set layout by route meta
        //     if (to.meta.layout !== undefined) {
        //         this.layout = to.meta.layout
        //     } else {
        //         this.layout = "DashboardLayout" // this is default layout if route meta is not set
        //     }
        //     },
        // },
        setup(props) {
            const store = useStore();
            const route = useRoute();
            // const router = useRouter();

            G.currentRoute = route;

            const def_lang = route.params && route.params.lang !== undefined ? route.params.lang.substring(0,2) : "az";
            store.setLang(def_lang);

            if( def_lang == 'us' ){
                moment.locale('en');
            }
            else if( def_lang == 'az' ){
                moment.locale(def_lang);
                moment.updateLocale('az', {
                    months: [
                        "Yanvar", "Fevral", "Mart", "Aprel", "May", "İyun",
                        "İyul", "Avqust", "Sentyabr", "Oktyabr", "Noyabr", "Dekabr"
                    ],
                    monthsShort: [
                        "Yan", "Fev", "Mar", "Apr", "May", "İyn",
                        "İyl", "Avq", "Sen", "Okt", "Noy", "Dek"
                    ],
                });
            }
            else{
                moment.locale(def_lang);
            }

            const gpage = G.current;

            const categories = ref([]);
            const top_menu_list = ref([]);
            const bottom_menu_list = ref([]);
            const socials = ref([]);
            const TR = ref([]);
            const langs = ref([]);

            gpage.page = (props.data && props.data.page !== undefined && props.data.page != '') ? (props.data.page || G.defaultPage) : G.defaultPage;
            gpage.data[gpage.page] = props.data ? props.data.data || "" : "";

            watchEffect(() => {
                TR.value = store.getTranslation();
                G.lang = TR.value;
            });

            onBeforeMount(async () => {
                await ajax({
                    url: store.getTranslations(),
                    success: (e) => {
                        // if (e && e.data) store.commit("setTranslations", e.data);
                        store.setTranslations(e.data);
                        // TR.value = store.getTranslation();
                        // G.lang = TR.value;
                    },
                    // error: () => {
                    //     // G.atoast.error('Server Connection Error !');
                    //     return null;
                    // }
                });

                await ajax({
                    url: store.getSystemSettings('system'),
                    success: async (x) => {
                        let res = x.data || null;

                        if ( x.status == 200 && res ) {
                            if( res.company !== undefined ){
                                for(let a in res){
                                    G.systemData[a] = {"value": res[a].value, "type": res[a].type};
                                }
                                document.getElementById("frontend_favicon1").setAttribute("href", G.systemData?.favicon?.value );
                                document.getElementById("frontend_favicon2").setAttribute("href", G.systemData?.favicon?.value );
                                document.getElementById("frontend_favicon3").setAttribute("href", G.systemData?.favicon?.value );
                            }
                            else{
                                G.systemData = res;
                            }

                            G.captcha_key.value = G.systemData?.google_recaptcha_v3?.value;

                            // G.systemData = res.reduce((m, o) => m.set(o.key, o), new Map);
                            // console.log(G.systemData);
                            // console.log(res.reduce((m, o) => m.set(o.key, o), new Map)); //.values();
                            // console.log(res.reduce((m, o) => m.set(o.key, {"value": o.value, "type": o.type}), new Map)); //.values();
                        }
                    },
                    // error: () => {
                    //     // console.log(e);
                    // }
                });

                // await ajax({
                //     url: store.getLangs(),
                //     success: (e) => {
                //         langs.value = e.data;
                //     }
                // });

                // await ajax({
                //     url: store.getMenus(),
                //     success: async (e) => {
                //         top_menu_list.value = e.data[0].children;
                //         bottom_menu_list.value = e.data[1].children;

                //     },
                // });

                await ajax({
                    url: store.getSocialNetwork(),
                    success: async (e) => {
                        socials.value = e.data;
                    },
                });

                // const f = (d) => {
                //     d.forEach(ci => {
                //         if( ci.children && ci.children.length > 0 ){
                //             f(ci.children);
                //         }
                //         // else{
                //         // }
                //         // ci.children = [];
                //         ci.link = `post_paging`;
                //         ci.link_param = {
                //             category_id: ci.id,
                //             // author_id: 0,
                //             page: 1,
                //             perpage: G.rowsPerPage,
                //             // sortfield: 'create_date',
                //             // sortorder: -1,
                //             // filters: '0',
                //             search_text: '',
                //         };
                //     });
                // };

                // await ajax({
                //     url: store.getCategoriesWithChildren(),
                //     success: (e) => {
                //         let cats = { link: '#', target: '', translate: [{name: '<i class="fas fa-bars fs-5" style=""></i>'}], children: e.data };
                //         // let cats = { link: '#', target: '', translate: {name: TR.value.products}, children: e.data };
                //         f(cats.children);
                //         categories.value = cats;
                //     }
                // });

            });

            // const rpath = router.resolve({name: 'index', lang: def_lang}).path;
            // useHead({
            //     title: computed(() => G.projectName),
            //     meta: [
            //         // Primary Meta Tags
            //         { name: 'title', content: computed(() => G.projectName)},
            //         { name: 'description', content: computed(() => G.projectInfo)},
            //         { name: 'robots', content: 'index, follow'},
            //         { name: 'viewport', content: 'width=device-width, initial-scale=1'},

            //         // Open Graph / Facebook
            //         { property: 'og:title', content: computed(() => G.projectName)},
            //         { property: 'og:description', content: computed(() => G.projectInfo)},
            //         { property: 'og:url', content: computed(() => `https://${G.main_host}${rpath}`)},
            //         { property: 'og:image', itemprop: 'image', content: computed(() => `https://${G.main_host}/favicon.png`)},
            //         { property: 'og:image:width', content: '600' },
            //         { property: 'og:image:height', content: '315' },
            //         { property: 'og:image:alt', content: computed(() => G.projectInfo) },
            //         { property: 'og:image:type', content: 'image/jpeg' },
            //         { property: 'og:site_name', content: computed(() => `https://${G.main_host}${rpath}`)},
            //         { property: 'og:locale', content: computed(() => `${def_lang}-${def_lang.toLocaleUpperCase()}`) },
            //         { property: 'og:type', content: 'article'},

            //         // Twitter
            //         { name: 'twitter:card', content: 'summary_large_image'},
            //         { name: 'twitter:title', content: computed(() => G.projectName)},
            //         { name: 'twitter:description', content: computed(() => G.projectInfo)},
            //         { name: 'twitter:url', content: computed(() => `https://${G.main_host}${rpath}`)},
            //         { name: 'twitter:image', content: computed(() => `https://${G.main_host}/favicon.png`)},
            //         { name: 'twitter:site', content: computed(() => `https://${G.main_host}${rpath}`)},
            //         { name: 'twitter:creator', content: computed(() => G.projectName) },
            //     ],
            // });

            // useSeoMeta({
            //     // Basic SEO
            //     title: computed(() => G.projectName),
            //     description: computed(() => G.projectInfo),

            //     // Open Graph
            //     ogTitle: computed(() => G.projectName),
            //     ogDescription: computed(() => G.projectInfo),
            //     ogImage: computed(() => `https://${G.main_host}/favicon.png`),
            //     ogUrl: computed(() => `https://${G.main_host}${rpath}`),
            //     ogType: 'article',
            //     // ogSiteName: 'Your Brand',

            //     // Twitter
            //     twitterCard: 'summary_large_image',
            //     twitterTitle: computed(() => G.projectName),
            //     twitterDescription: computed(() => G.projectInfo),
            //     twitterImage: computed(() => `https://${G.main_host}/favicon.png`),

            //     // Product specific (structured data will be generated)
            //     // articleAuthor: 'Author Name',
            //     // articlePublishedTime: '2023-01-01',
            //     // articleModifiedTime: '2023-02-15',
            // });


            // const setComponent = (val) => {
            //     // val = val.replace(/^\//, "");
            //     // gpage.page = G.capitalize(val);

            //     // document.getElementsByTagName('body')[0].style='';

            //     gpage.page = val;
            //     gpage.data[gpage.page] = {};

            //     router.push({
            //         name: val,
            //         // params: {
            //         //     // soldier_id: route.params.soldier_id || 2,
            //         // },
            //         // params: Object.assign(
            //         //     {
            //         //         page: 1,
            //         //         perpage: prm.limit || G.rowsPerPage,
            //         //     },
            //         //     route_obj.value
            //         // ),
            //     });
            // };

            const currentComponent = computed(() => {
                return gpage.data[gpage.page] || {};
            });

            const loadPages = computed(() => {
                return defineAsyncComponent({
                    loader: () => import(`@/${gpage.page}`),
                    errorComponent:
                        defineAsyncComponent(() =>
                            import('@/pages/NotFound')
                        ),
                    // timeout: 3000,
                    // suspensible: false,
                });
            });

            return {
                G,
                TR,
                currentComponent,
                loadPages,
                // setComponent,
                langs,
                top_menu_list,
                bottom_menu_list,
                categories,
                socials,
            };
        },
    };
</script>


<style lang="scss">
    /*.main-content {
        width: calc(100% - 275px);
        // height: calc( 100% - 50px );
        // max-height: calc( 100% - 90px );
        // margin-bottom: 60px;
    }
    .main {
        // height: calc( 100vh - 10px );
        max-height: calc( 100vh - 95px );
        // margin-bottom: 60px;
        overflow: hidden;
        overflow-y: scroll;
    }
    .main > .row, .main > .row > .col-12{
        margin: 0px;
        padding: 0px;
    }
    @media (max-width: 576px) {
        .main-content {
            width: 100%;
        }
    }*/
    // .main-content {
    //     width: calc(100% - 250px);
    //     // height: calc( 100% - 50px );
    //     // max-height: calc( 100% - 90px );
    //     // margin-bottom: 60px;
    // }
    // .main-body-content {
    //     // height: calc( 100vh - 95px );
    //     // max-height: calc( 100vh - 95px );
    //     height: calc( 100vh - 79px );
    //     max-height: calc( 100vh - 79px );

    //     // margin-bottom: 60px;
    //     overflow: hidden;
    //     overflow-y: scroll;
    //     padding: 4px 0px;
    // }
    // .main-body-content > .row, .main-body-content > .row > .col-12{
    //     margin: 0px;
    //     padding: 0px;
    // }
    @media (max-width: 576px) {
        .pt-100{
            padding-top: 0px;
        }
    //     .main-content {
    //         width: 100%;
    //     }
    //     .main-body-content {
    //         height: calc( 100vh - 103px );
    //         max-height: calc( 100vh - 103px );
    //         padding: 4px 0px;
    //     }
    }
</style>

